import { format } from "date-fns";

export const formatDateForSQL = (date) => {
  return format(date, "yyyy-MM-dd");
};
